import { render, staticRenderFns } from "./OrderWarranties.vue?vue&type=template&id=484a9dfa&scoped=true&"
import script from "./OrderWarranties.vue?vue&type=script&lang=js&"
export * from "./OrderWarranties.vue?vue&type=script&lang=js&"
import style0 from "./OrderWarranties.vue?vue&type=style&index=0&id=484a9dfa&lang=scss&scoped=true&"
import style1 from "./OrderWarranties.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a9dfa",
  null
  
)

export default component.exports